import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import i18next from 'i18next';
import { debounce } from 'lodash-es';
import { useHistory, useLocation } from 'react-router';
import { convertSearchUrl, getFilterFromUrl } from 'utils/tools';

const SearchTemplateInput = ({ retrieveList, resetPage }) => {
  const { search } = useLocation();
  const { filter: restFilter } = getFilterFromUrl(search);
  const { push } = useHistory();

  const debounceSearch = debounce((value) => {
    resetPage();

    const filter = {
      jobTemplate: value,
    };

    push({
      search: `?${convertSearchUrl({
        ...restFilter,
        filter,
      })}`,
    });

    retrieveList({
      filter: {
        filter: filter?.jobTemplate ? filter : undefined,
      },
      isRefresh: true,
    });
  }, 400);

  const onChange = (e) => {
    const searchText = e.target.value;
    debounceSearch(searchText);
  };

  const renderPrefix = () => (
    <SearchOutlined size={14} className="text-gray-500 mr-10" />
  );

  return (
    <Input
      allowClear
      prefix={renderPrefix()}
      placeholder={i18next.t('jobs.searchTemplatePlaceholder')}
      onChange={onChange}
      defaultValue={restFilter.filter?.jobTemplate || ''}
    />
  );
};

SearchTemplateInput.propTypes = {
  retrieveList: PropTypes.func,
  resetPage: PropTypes.func,
};

export default SearchTemplateInput;
